import { Modal } from "@bluframe/blublocks"
import ConfirmModal from "components/ConfirmModal"

import { ComponentProps } from "."
import EditInputs from "./EditInputs"
import HeaderButtons from "./HeaderButtons"
import HeaderTitle from "./HeaderTitle"
import { Form, Main, Preview, Subject, SubjectAndPreview, Top } from "./styled"

const Item = ({
  actionButtonLabel,
  actionButtonOnClick,
  errors,
  footerIdRef,
  headingIdRef,
  htmlRef,
  identifierRef,
  isEditMode,
  isModalOpen,
  isSaveLoading,
  isTemplate,
  item,
  nameRef,
  onModalClose,
  onModalConfirm,
  onPreviewClick,
  onSubmit,
  outlinedButtonLabel,
  outlinedButtonOnClick,
  placeholdersRef,
  preview,
  subjectPreview,
  subjectRef
}: ComponentProps) => (
  <Form onSubmit={onSubmit}>
    <Top>
      <HeaderTitle
        errors={errors}
        identifierRef={identifierRef}
        isEditMode={isEditMode}
        isTemplate={isTemplate}
        item={item}
        nameRef={nameRef}
        placeholdersRef={placeholdersRef}
      />

      <HeaderButtons
        actionButtonLabel={actionButtonLabel}
        actionButtonOnClick={actionButtonOnClick}
        isEditMode={isEditMode}
        isSaveLoading={isSaveLoading}
        onPreviewClick={onPreviewClick}
        outlinedButtonLabel={outlinedButtonLabel}
        outlinedButtonOnClick={outlinedButtonOnClick}
      />
    </Top>

    <Main $isEditing={isEditMode}>
      {isEditMode ? (
        <EditInputs
          errors={errors}
          footerIdRef={footerIdRef}
          headingIdRef={headingIdRef}
          htmlRef={htmlRef}
          isTemplate={isTemplate}
          item={item}
          subjectRef={subjectRef}
        />
      ) : null}

      <SubjectAndPreview>
        <Subject>{subjectPreview}</Subject>

        <Preview
          dangerouslySetInnerHTML={{
            __html: preview ?? ""
          }}
        />
      </SubjectAndPreview>
    </Main>

    <Modal isOpen={isModalOpen} onClose={onModalClose}>
      <ConfirmModal
        message={`Are you sure you want to delete ${item?.name}?`}
        onClose={onModalClose}
        onConfirm={onModalConfirm}
      />
    </Modal>
  </Form>
)

export default Item
